<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">我的报名</div>

      <!-- 查询区域 -->
      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="提交时间">
            <a-range-picker style="width: 250px" :placeholder="['开始日期','结束日期']" />
          </a-form-item>

          <a-form-item label="当前状态">
            <a-select placeholder="请选择审核节点" style="width: 180px">
              <a-select-option value="all">全部</a-select-option>
              <a-select-option value="review">机构审核</a-select-option>
              <a-select-option value="contract">合同审核</a-select-option>
              <a-select-option value="confirm">最终确认</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="关键词">
            <a-input-search placeholder="请输入项目名称或标的名称" style="width: 250px" />
          </a-form-item>

          <a-button type="primary" style="margin-top: 4px;">查询</a-button>
          <a-button style="margin-left: 10px;">重置</a-button>
        </a-form>
      </div>

      <!-- 表格区域 -->
      <a-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        :pagination="{ pageSize: 10, total: data.length }"
        :scroll="{ x: 1400 }"
      >
        <template slot="projectCode" slot-scope="text">
          <a style="color: #1890ff;">{{ text }}</a>
        </template>

        <template slot="projectName" slot-scope="text">
          <a style="color: #1890ff;">{{ text }}</a>
        </template>

        <template slot="operation">
          <a style="color: #1890ff; margin-right: 8px;">修改</a>
          <a style="color: #1890ff; margin-right: 8px;">项目函件</a>
          <a style="color: #1890ff;">竞价方案预知</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>


<script>
export default {
  data() {
    return {
      columns: [
        { title: '项目编号', dataIndex: 'projectCode', key: 'projectCode', scopedSlots: { customRender: 'projectCode' }, width: 180 },
        { title: '项目名称', dataIndex: 'projectName', key: 'projectName', scopedSlots: { customRender: 'projectName' }, width: 250 },
        { title: '保证金状态', dataIndex: 'depositStatus', key: 'depositStatus', width: 120 },
        { title: '机构审核结果', dataIndex: 'orgReview', key: 'orgReview', width: 140 },
        { title: '合同审核结果', dataIndex: 'contractReview', key: 'contractReview', width: 140 },
        { title: '最终资格确认结果', dataIndex: 'finalConfirm', key: 'finalConfirm', width: 160 },
        { title: '当前状态', dataIndex: 'currentStatus', key: 'currentStatus', width: 200 },
        { title: '项目负责人', dataIndex: 'principal', key: 'principal', width: 120 },
        { title: '负责人联系方式', dataIndex: 'contact', key: 'contact', width: 160 },
        { title: '操作', key: 'operation', fixed: 'right', width: 240, scopedSlots: { customRender: 'operation' } },
      ],
      data: []
    };
  }
};

</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input{
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
</style>